import { render, staticRenderFns } from "./BafaTables.vue?vue&type=template&id=4ab87536&scoped=true&"
import script from "./BafaTables.vue?vue&type=script&lang=js&"
export * from "./BafaTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab87536",
  null
  
)

export default component.exports